import { normalizeTabHash } from './tabHash';

// const tabs = document.querySelectorAll('.product-info-tabs .tab-list .tab');
// const panels = document.querySelectorAll('.product-info-tabs .tab-content .tab-panel');

// export function initTabs() {
//     if (tabs) {
//         // Add event listeners to tabs
//         tabs.forEach(tab => {
//             tab.addEventListener('click', function() {
//                 removeActiveClass();

//                 // set aria-selected to true on the clicked tab
//                 this.setAttribute('aria-selected', 'true');

//                 // Activate the clicked tab
//                 this.classList.add('active');

//                 // Find the corresponding tab panel by ID and activate it
//                 const tabId = this.getAttribute('data-tab');
//                 document.querySelector(`.product-info-tabs .tab-content #${tabId}`).classList.add('active');
//             });
//         });
//     }

//     function removeActiveClass() {
//         tabs.forEach(tab => {
//             tab.classList.remove('active');
//             tab.setAttribute('aria-selected', 'false');
//         });
//         panels.forEach(panel => panel.classList.remove('active'));
//     }
// }



function centerActiveTab() {
  const tabList = document.querySelector('.tab-list') as HTMLElement;
  const activeTab = tabList.querySelector('.tab.active') as HTMLElement;

  if (!tabList || !activeTab) return;

  const offset = activeTab.offsetLeft;
  const tabWidth = activeTab.offsetWidth;
  const containerWidth = tabList.clientWidth;
  const scrollWidth = tabList.scrollWidth;

  let scrollTo = offset - (containerWidth / 2) + (tabWidth / 2);
  scrollTo = Math.max(0, Math.min(scrollTo, scrollWidth - containerWidth));

  tabList.scrollTo({
    left: scrollTo,
    behavior: 'smooth',
  });
}

function updateScrollUI() {
  const wrapper = document.querySelector('.tab-wrapper');
  const tabList = document.querySelector('.tab-list') as HTMLElement;
  const leftArrow = document.querySelector('.scroll-arrow.left') as HTMLElement;
  const rightArrow = document.querySelector('.scroll-arrow.right') as HTMLElement;

  if (!wrapper || !tabList || !leftArrow || !rightArrow) return;

  const scrollLeft = tabList.scrollLeft;
  const scrollWidth = tabList.scrollWidth;
  const clientWidth = tabList.clientWidth;

  const atStart = scrollLeft <= 0;
  const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

  wrapper.classList.toggle('fade-left', !atStart);
  wrapper.classList.toggle('fade-right', !atEnd);

  leftArrow.classList.toggle('inactive', atStart);
  rightArrow.classList.toggle('inactive', atEnd);
}

/** Wird von activateTab am Tab-Button ausgelöst (bubbelt). */
export const TAB_ACTIVATED_EVENT = 'pdp:tabactivated';

/**
 * Aktiviert einen Tab samt Panel. Wird vom Click-Handler und vom Deep-Link (#anker) genutzt,
 * deshalb unabhängig davon, ob initTabScrollUI schon gelaufen ist.
 */
export function activateTab(tab: HTMLElement) {
  document.querySelectorAll('.tab-list .tab').forEach(t => {
    t.classList.remove('active');
    t.setAttribute('aria-selected', 'false');
  });

  tab.classList.add('active');
  tab.setAttribute('aria-selected', 'true');

  // Get target panel ID from data-tab or aria-controls
  const targetId = tab.getAttribute('data-tab') || tab.getAttribute('aria-controls');
  const targetPanel = targetId ? document.getElementById(targetId) : null;

  document.querySelectorAll('.tab-panel').forEach(panel => panel.classList.remove('active'));
  targetPanel?.classList.add('active');

  centerActiveTab();
  updateScrollUI();

  // Für Tabs, die ihren Inhalt erst beim Öffnen laden – egal ob per Klick oder per #anker.
  tab.dispatchEvent(new CustomEvent(TAB_ACTIVATED_EVENT, { bubbles: true }));
}

/**
 * Entfernt einen Tab-Button (z.B. wenn ein nachgeladener Tab keinen Inhalt hat). War er aktiv –
 * etwa weil er per #anker geöffnet wurde –, wird vorher auf "Produktdaten" gewechselt (dem
 * Standard-Tab der Seite) bzw. auf den ersten verbleibenden Tab, falls es den nicht gibt.
 */
export function removeTab(tab: HTMLElement | null) {
  if (!tab) return;

  if (tab.classList.contains('active')) {
    const defaultTab = document.getElementById('tab-produktdaten');
    const fallback = defaultTab && defaultTab !== tab
      ? defaultTab
      : Array.from(document.querySelectorAll<HTMLElement>('.tab-list .tab')).find(t => t !== tab);

    if (fallback) {
      activateTab(fallback);

      // Sonst zeigt die URL weiter auf einen Tab, den es nicht mehr gibt, und wird so geteilt.
      if (tab.dataset.tabAnchor && normalizeTabHash(window.location.hash) === tab.dataset.tabAnchor) {
        writeTabAnchorToUrl(fallback);
      }
    }
  }

  tab.remove();
}

/**
 * Schreibt den Anker des Tabs in die URL, ohne History-Eintrag und ohne Sprung. Nur für den seltenen
 * Fall in removeTab – nicht bei Tab-Klicks, siehe initTabScrollUI.
 */
function writeTabAnchorToUrl(tab: HTMLElement) {
  const anchor = tab.dataset.tabAnchor;
  if (!anchor) return;

  const url = new URL(window.location.href);
  url.hash = anchor;
  history.replaceState(history.state, '', url.toString());
}

export function initTabScrollUI() {
  const tabList = document.querySelector('.tab-list') as HTMLElement;
  const leftArrow = document.querySelector('.scroll-arrow.left') as HTMLElement;
  const rightArrow = document.querySelector('.scroll-arrow.right') as HTMLElement;
  const tabs = document.querySelectorAll('.tab-list .tab');

  if (!tabList || !leftArrow || !rightArrow) return;

  // Scroll on arrow click
  leftArrow.addEventListener('click', () => {
    tabList.scrollBy({ left: -120, behavior: 'smooth' });
  });

  rightArrow.addEventListener('click', () => {
    tabList.scrollBy({ left: 120, behavior: 'smooth' });
  });

  // Watch scroll and resize
  tabList.addEventListener('scroll', updateScrollUI);
  window.addEventListener('resize', updateScrollUI);

  // Watch tab click to re-center
tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    // Bewusst kein Anker in die URL: replaceState bei jedem Klick würde History-Change-Trigger im
    // Tracking (GTM/GA4) auslösen.
    activateTab(tab as HTMLElement);
  });
});


  // Initial update
  centerActiveTab();
  updateScrollUI();
}

// Initialize on DOM ready
window.addEventListener('DOMContentLoaded', initTabScrollUI);

